import { useState } from "react";
import { onWrite, scan } from "./nfc.adapter";
import "./style.scss";

const NFCPage = () => {
  const [readStatus, setReadStatus] = useState<string>("");
  const [writeStatus, setWriteStatus] = useState<string>("");
  const [serialNumber, setSerialNumber] = useState<string>("");
  const [value, setValue] = useState<string>("");
  const [inputValue, setInputValue] = useState<string>("");

  const onScanNFC = () => {
    setReadStatus("Scanning....");
    setSerialNumber("");
    setValue("");
    scan(onSuccessScan, onErrorScan);
  };

  const onSuccessScan = (event: any) => {
    const { message, serialNumber } = event;
    setReadStatus("Read Success");
    setSerialNumber(serialNumber);

    for (const record of message.records) {
      switch (record.recordType) {
        case "text":
          const textDecoder = new TextDecoder(record.encoding);
          console.log("Message: ", textDecoder.decode(record.data));
          setValue(textDecoder.decode(record.data));
          break;
        case "url":
          break;
        default:
          break;
      }
    }
  };

  const onErrorScan = (error: any) => {
    setReadStatus(`Read Error: ${error}`);
  };

  const onWriteNFC = () => {
    setWriteStatus("Writing...");
    onWrite(
      inputValue,
      () => {
        setWriteStatus("Write Success!");
      },
      (error: any) => {
        setWriteStatus(`Write Error: ${error}`);
      }
    );
  };

  return (
    <div className="nfc-page-wrapper">
      <h1>NFC page test</h1>

      <div className="scan-section">
        <button onClick={onScanNFC}>Scan</button>
        <div>{readStatus}</div>

        <div>Serial Number: {serialNumber}</div>
        <div>Message: {value}</div>
      </div>

      <div className="write-section">
        <h3>Write NFC</h3>
        Message:{" "}
        <input
          type="text"
          value={inputValue}
          onChange={(e: any) => setInputValue(e.target.value)}
        />
        <button onClick={onWriteNFC}>Write</button>
        <div>{writeStatus}</div>
      </div>
    </div>
  );
};

export default NFCPage;
